export class ActualParameter {
    code: string;
    value: string;
    valueText: string;
    tag: string;
    fetchValueMode?: any;
    fetchValueSetting?: any;
}